/**
 * Stabil farge per seilnummer (samme nummer → samme farge). Hashen sprer fortløpende
 * nummer (GJ218, GJ219, GJ220 …) over fargehjulet — den gamle ga dem nesten lik
 * farge — og gule toner, som synes dårlig på sjøkartet, hoppes over.
 */
export function colorForSail(sail: string): string {
  let h = 2166136261; // FNV-1a + blanding
  for (let i = 0; i < sail.length; i++) {
    h ^= sail.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  h ^= h >>> 13;
  h = Math.imul(h, 0x5bd1e995);
  h ^= h >>> 15;
  let hue = (h >>> 0) % 330;
  if (hue >= 45) hue += 30; // hopp over gult (45–75°)
  return `hsl(${hue}, 80%, 55%)`;
}
